import React, { useState } from "react";
import TextInputModal from "../../../TextInputModal";
import { GiSave } from "react-icons/gi";
import { LongButton } from "../../../Buttons";
import { phonenumberValid } from "../../../../../helpers/Utils";
import useFetch from "../../../../../hooks/useFetch";
import { buildCountriesArray } from "../../../../../helpers/OrdersFunctionsGlobal";
import SelectInput from "../../../SelectInput";
import { UlElements } from "../../../StyledComponents";

const sanitizeNumeric = (value) => String(value || "").replace(/[\s.]/g, "");
const sanitizePhone = (value) => String(value || "").replace(/[^0-9+]/g, "");

function ShippingAddressComponent({
  shipping_address,
  shippingAdr_action_edit,
  updateOrderAddress,
  customer,
  module_name,
}) {
  const [shippingAdr, setShippingAdr] = useState(shipping_address);
  const handleChangeText = (e) => {
    const { name, value } = e.target;
    setShippingAdr({
      ...shippingAdr,
      [name]: value,
    });
  };
  const handleChangeNumeric = (e) => {
    handleChangeText({
      ...e,
      target: {
        ...e.target,
        name: e.target.name,
        value: sanitizeNumeric(e.target.value),
      },
    });
  };
  const handleChangePhone = (e) => {
    handleChangeText({
      ...e,
      target: {
        ...e.target,
        name: e.target.name,
        value: sanitizePhone(e.target.value),
      },
    });
  };
  const phonenumber = phonenumberValid(shipping_address.phone);
  // const haveRivileShops = module_name == "upickupatstore" && false;
  if (shippingAdr_action_edit) {
    return (
      <ShippingForm
        UlElements={UlElements}
        updateOrderAddress={updateOrderAddress}
        shippingAdr={shippingAdr}
        handleChangeText={handleChangeText}
      />
    );
  }
  return (
    <React.Fragment>
      <UlElements>
        {module_name !== "upickupatstore" && (
          <>
            <li>
              {shipping_address.firstname} {shipping_address.lastname}
            </li>
          </>
        )}
        <li>{shipping_address.street}</li>
        {shipping_address.street2 !== null && (
          <li>{shipping_address.street2}</li>
        )}
        <li>
          {shipping_address?.country && `${shipping_address.country.en_name}, `}
          {shipping_address.city}, {shipping_address.postal_code}
        </li>
        {module_name !== "upickupatstore" && (
          <>
            <li className={phonenumber ? "" : "text-danger"}>
              {shipping_address.phone}
            </li>
            <li>{shipping_address.other}</li>
          </>
        )}
        {customer.consultant_code !== null && (
          <li>Consultant: {customer.consultant_code}</li>
        )}
        {customer.rline && (
          <li>
            <span className="text-danger">[R-Line]:</span>
            {customer.rline_code}
          </li>
        )}

        {customer.rline && (
          <LongButton
            text={customer.email}
            style={{
              backgroundColor: "silver",
              color: "black",
              fontSize: "0.8rem",
              height: "24px",
            }}
          />
        )}
      </UlElements>
    </React.Fragment>
  );
}

const ShippingForm = ({
  UlElements,
  updateOrderAddress,
  shippingAdr,
  handleChangeText,
}) => {
  const [errors, setErrors] = useState({});
  const { value: countriesData } = useFetch("/api/v1/countries");
  const countries = buildCountriesArray(countriesData?.data);

  const handleChangeNumeric = (e) => {
    handleChangeText({
      ...e,
      target: {
        ...e.target,
        name: e.target.name,
        value: sanitizeNumeric(e.target.value),
      },
    });
  };
  const handleChangePhone = (e) => {
    handleChangeText({
      ...e,
      target: {
        ...e.target,
        name: e.target.name,
        value: sanitizePhone(e.target.value),
      },
    });
  };

  const validate = () => {
    const newErrors = {};

    if (!shippingAdr.firstname || shippingAdr.firstname.trim() === "") {
      newErrors.firstname = ["First name is required"];
    }
    if (!shippingAdr.lastname || shippingAdr.lastname.trim() === "") {
      newErrors.lastname = ["Last name is required"];
    }
    if (!shippingAdr.country_id) {
      newErrors.country_id = ["Country is required"];
    }
    if (!shippingAdr.street || shippingAdr.street.trim() === "") {
      newErrors.street = ["Address is required"];
    }
    if (!shippingAdr.city || shippingAdr.city.trim() === "") {
      newErrors.city = ["City is required"];
    }
    if (!shippingAdr.postal_code || shippingAdr.postal_code.trim() === "") {
      newErrors.postal_code = ["Postal code is required"];
    }
    if (!shippingAdr.phone || shippingAdr.phone.trim() === "") {
      newErrors.phone = ["Phone is required"];
    } else if (!phonenumberValid(shippingAdr.phone)) {
      newErrors.phone = ["Invalid phone number"];
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) {
      updateOrderAddress("shipping", shippingAdr);
    }
  };

  return (
    <UlElements>
      <li>
        <TextInputModal
          text="First name"
          placeholder="Enter"
          name="firstname"
          value={shippingAdr.firstname}
          onChange={(e) => handleChangeText(e, "shippingAdr")}
          error={errors.firstname}
        />
      </li>
      <li>
        <TextInputModal
          text="Last name"
          placeholder="Enter"
          name="lastname"
          value={shippingAdr.lastname}
          onChange={(e) => handleChangeText(e, "shippingAdr")}
          error={errors.lastname}
        />
      </li>
      <li>
        <SelectInput
          required={true}
          label="Country"
          value={shippingAdr.country_id || undefined}
          onChange={(value) =>
            handleChangeText(
              { target: { value, name: "country_id" } },
              "shippingAdr"
            )
          }
          options={countries}
          error={errors.country_id}
        />
      </li>
      <li>
        <TextInputModal
          text="Address"
          placeholder="Enter"
          name="street"
          value={shippingAdr.street}
          onChange={(e) => handleChangeText(e, "shippingAdr")}
          error={errors.street}
        />{" "}
      </li>

      <li>
        <TextInputModal
          text="City"
          placeholder="Enter"
          name="city"
          value={shippingAdr.city}
          onChange={(e) => handleChangeText(e, "shippingAdr")}
          error={errors.city}
        />{" "}
      </li>
      <li>
        <TextInputModal
          text="Postal code"
          placeholder="Enter"
          name="postal_code"
          value={shippingAdr.postal_code}
          onChange={(e) => handleChangeNumeric(e)}
          error={errors.postal_code}
        />{" "}
      </li>
      <li>
        <TextInputModal
          text="Phone"
          placeholder="Enter"
          name="phone"
          value={shippingAdr.phone}
          onChange={(e) => handleChangePhone(e)}
          error={errors.phone}
        />{" "}
      </li>
      <li>
        <TextInputModal
          text="Email"
          placeholder="Enter"
          name="other"
          value={shippingAdr.other}
          onChange={(e) => handleChangeText(e, "shippingAdr")}
          error={errors.other}
        />
      </li>
      <li className="my-3">
        <button
          className="btn btn-sm btn-primary"
          style={{ width: "100%" }}
          onClick={handleSubmit}
        >
          <GiSave />
          {"Update"}
        </button>
      </li>
    </UlElements>
  );
};

export default ShippingAddressComponent;
